'use client';

import React from 'react';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import { config } from '@shared/config';

const PreviewProvider = ({ children }: { children: React.ReactNode }) => (
    <ContentfulLivePreviewProvider
        locale={config.language.default || 'en-GB'}
        enableInspectorMode={true}
        enableLiveUpdates={true}
        targetOrigin="https://app.contentful.com"
    >
        {children}
    </ContentfulLivePreviewProvider>
);

export default PreviewProvider;
